// extracted by mini-css-extract-plugin
export default {"whyUs":"WhyUs_whyUs__tfvMx","whyUsTitle":"WhyUs_whyUsTitle__vpIv7","whyUsCardContainer":"WhyUs_whyUsCardContainer__0I8-3"};